import React, { useState } from 'react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Riceverai immediatamente un’e-mail con il link per scaricare tutti i file PDF e i Bonus.'
}, {
  q: 'È adatto per docenti di sostegno o supplenti?',
  a: 'Assolutamente sì. È una risorsa preziosa per chiunque debba gestire l’ora di immagine in modo professionale e strutturato.'
}, {
  q: 'Le schede sono fotocopiabili?',
  a: "Sì, tutto il materiale è progettato per essere stampato in bianco e nero o a colori, mantenendo un'ottima risoluzione."
}, {
  q: 'La valutazione è aggiornata alle ultime linee guida?',
  a: 'Sì, le griglie seguono i criteri della valutazione descrittiva introdotti recentemente dal MIUR.'
}, {
  q: 'Per quali classi è pensato il kit?',
  a: 'Il percorso è strutturato in 6 volumi pensati per la Scuola Secondaria di Primo e Secondo Grado, con attività modulabili e adattabili a diverse fasce d’età e livelli di competenza.'
}, {
  q: 'Quali metodi di pagamento accettate?',
  a: 'Accettiamo tutte le principali carte di credito e debito (Visa, Mastercard, American Express), PayPal e Apple Pay. Il pagamento è unico, sicuro e protetto da crittografia SSL.'
}, {
  q: 'Posso usare il materiale anche se non ho una LIM in classe?',
  a: 'Certamente. Tutto il materiale è disponibile in formato PDF stampabile, quindi può essere utilizzato in qualsiasi contesto. Il materiale per la LIM è un valore aggiunto per chi ne dispone.'
}, {
  q: 'Come funziona la garanzia di 7 giorni?',
  a: 'Hai 7 giorni di tempo dall’acquisto per esaminare tutto il kit. Se non sei pienamente soddisfatto, ti basta inviarci un’e-mail e riceverai il rimborso completo, senza domande e senza complicazioni.'
}, {
  q: 'Il materiale è scaricabile per sempre?',
  a: 'Sì, una volta acquistato il kit è tuo per sempre. Potrai scaricare i file sul tuo dispositivo e riutilizzarli ogni anno scolastico, senza alcun limite di tempo o di download.'
}, {
  q: 'Riceverò aggiornamenti futuri del materiale?',
  a: 'Sì, tutti gli aggiornamenti dei contenuti già inclusi nel kit sono gratuiti e ti verranno inviati automaticamente via e-mail, così avrai sempre a disposizione la versione più recente.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-66">
      <div className="max-w-3xl mx-auto" data-id="element-67">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-68">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-16" data-id="element-69">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-70">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-71">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-72">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-73">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-74">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-75">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-76">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-77"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-4 w-full sm:w-auto max-w-2xl text-gray-900 shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-78">
            💪 SÌ! VOGLIO RIVOLUZIONARE LE MIE LEZIONI ORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-79">
            <span data-id="element-80">⚡ Accesso Immediato</span>
            <span data-id="element-81">•</span>
            <span data-id="element-82">🛡️ Garanzia di 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}